import { Link, StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';

export interface SubstandardLetterContentProps {
  carrier: Carriers;
  isJuvenile?: boolean;
}

const SubstandardLetterContent = ({
  carrier,
  isJuvenile = false,
}: SubstandardLetterContentProps) => (
  <>
    <Text style={styles.text}>
      Thank you for applying for life insurance with{' '}
      {CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName()}. This
      letter is for your information only.
    </Text>
    {isJuvenile ? (
      <Text style={styles.text}>
        We are informing you that the life insurance coverage for the proposed
        life insured has been approved. However, based on our underwriting
        review, the policy has been issued at a premium rate higher than what
        was initially quoted at the time of application. Please note that there
        will be no further pricing changes resulting from this notification.
      </Text>
    ) : (
      <Text style={styles.text}>
        We are letting you know your life insurance coverage has been approved
        at a rate higher than the rate you were initially quoted when you first
        applied. There will be no further pricing changes as a result of this
        letter.
      </Text>
    )}
    <Text style={styles.text}>
      If you have activated coverage, no action is required. Your policy will
      continue to remain in force as long as you continue to pay your current
      premiums as scheduled. If you have not activated coverage, you can do so
      by paying your initial premium. Once your policy has been activated, your
      premium payment amounts will remain as shown on your policy schedule.
    </Text>
    <Text style={styles.text}>
      You have the right to know the specific reason why your application was
      approved with a different premium rate. This may be requested by emailing
      Ethos <Text style={styles.bold}>within 6 months</Text> of the date of this
      letter at{' '}
      <Link href="mailto:accounts@ethoslife.com">accounts@ethoslife.com</Link>,
      one of our representatives will be glad to help.
    </Text>
    <Text style={styles.text}>
      The attached notice describes your rights to access the information
      obtained for our files and explains the steps you may take if you believe
      the information is incorrect. This information supplements the material
      already given to you at the time of your application for coverage.
    </Text>
  </>
);

const styles = StyleSheet.create({
  text: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 12,
  },
  bold: {
    fontWeight: '700',
  },
});

export default SubstandardLetterContent;
